// 侧边栏顶部logo
<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <img
        v-if="collapse"
        key="collapse"
        src="../../../assets/icon/logo/logo@2x(1).png"
        class="sidebar-logo"
      />
      <img
        v-else
        key="expand"
        src="../../../assets/icon/logo/logo@2x.png"
        class="sidebar-logo"
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-logo-container {
  height: 66px;
}
.sidebar-logo {
  height: 66px;
}
// .sidebarLogoFade-enter-active {
//   transition: opacity 1.5s;
// }

// .sidebarLogoFade-enter,
// .sidebarLogoFade-leave-to {
//   opacity: 0;
// }

// .sidebar-logo-container {
//   position: relative;
//   width: 100%;
//   height: 50px;
//   line-height: 50px;
//   background: #2b2f3a;
//   text-align: center;
//   overflow: hidden;

//   & .sidebar-logo-link {
//     height: 100%;
//     width: 100%;

//     & .sidebar-logo {
//       width: 32px;
//       height: 32px;
//       vertical-align: middle;
//       margin-right: 12px;
//     }

//     & .sidebar-title {
//       display: inline-block;
//       margin: 0;
//       color: #fff;
//       font-weight: 600;
//       line-height: 50px;
//       font-size: 14px;
//       font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
//       vertical-align: middle;
//     }
//   }

//   &.collapse {
//     .sidebar-logo {
//       margin-right: 0px;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue